import React, { useState } from "react";
import "./styles/opinions.sass";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import quote from "./img/quote.svg";
import {
  faStarHalf,
  faStar,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import CheckWidth from "./CheckWidht";
const opinions = [
  {
    id: 1,
    name: "Andrzej",
    stars: 4.5,
    text: "Wymienialem dzisiaj filtr paliwa u Pana Mateusza. Bardzo kulturalny i profesjonalny mechanik. Polecam",
  },
  {
    id: 2,
    name: "Patryk",
    stars: 5,
    text: "Przemiły Pan Mechanik, który od strony diagnozowania problemu, naprawy po rozliczenia jest prawdziwym profesjonalistom. Pan blacharz fachowiec, których w Polsce coraz mniej.",
  },
  {
    id: 3,
    name: "Grzegorz",
    stars: 5,
    text: "Świetna robota, robota wykonana na 100%",
  },
];

const OpinionItem = ({ opinion }) => {
  const [moreTxt, setMoreTxt] = useState(false);
  return (
    <div className="opinions">
      <div>
        <div className="photo">
          <p>{opinion.name[0]}</p>
        </div>
        <h3>{opinion.name}</h3>
        <img src={quote} alt="cytat" />
      </div>

      {/* <div className="stars_box">
        {opinion.stars % 1 === 0 ? (
          [...Array(opinion.stars)].map((_, i) => (
            <FontAwesomeIcon icon={faStar} key={`${opinion.id}-star-${i}`} />
          ))
        ) : (
          <>
            {[...Array(Math.floor(opinion.stars))].map((_, i) => (
              <FontAwesomeIcon icon={faStar} key={`${opinion.id}-star-${i}`} />
            ))}
            <FontAwesomeIcon
              icon={faStarHalf}
              key={`${opinion.id}-half-star`}
            />
          </>
        )}
      </div> */}
      {CheckWidth() < 1024 ? (
        <>
          <p
            className={`opinion_text ${
              moreTxt ? "opinion_text_less" : "opinion_text_more"
            }`}
          >
            {moreTxt
              ? opinion.text
              : opinion.text.length > 110
              ? `${opinion.text.slice(0, 110)}...`
              : opinion.text}
          </p>

          {opinion.text.length > 110 && (
            <button aria-label="More" onClick={() => setMoreTxt(!moreTxt)}>
              <FontAwesomeIcon
                icon={faAngleRight}
                rotation={moreTxt ? 270 : 90}
                style={{ cursor: "pointer" }}
              />
            </button>
          )}
        </>
      ) : (
        <p className="pc_opinion_text">{opinion.text}</p>
      )}
    </div>
  );
};

const Opinions = () => {
  return (
    <div className="opinions_box">
      <h2>Opinie</h2>
      {opinions.map((opinion) => (
        <OpinionItem key={opinion.id} opinion={opinion} />
      ))}
    </div>
  );
};
export default Opinions;
